<template>
  <OsTabGuide
    :ios-images="getLabel('ios')"
    :android-images="getLabel('android')"
  />
</template>
<script setup lang="ts">
definePageMeta({
  layout: 'center'
})
useHead({
  title: '가이드'
})
const { setting } = useRoute().query

const imageLabels: { [key: string]: { ios: ImageLabel[]; android: ImageLabel[] } } = {
  apn: { //guide/use?setting=apn
    ios: ['img-guide-ios-7'],
    android: ['img-guide-aos-6']
  },
  delete: { //guide/use?setting=delete
    ios: ['img-guide-ios-6'],
    android: ['img-guide-aos-5']
  },
  error: { //guide/use?setting=error
    ios: ['img-guide-ios-7'],
    android: ['img-guide-aos-6']
  }
}
const getLabel = (os: OS): ImageLabel[] => {
  if (!setting) {
    return []
  }
  return imageLabels[setting as string][os]
}

</script>
